export const DEFAULT_SUGGESTION_SIZE = 20;
export const PUBLISH_DRAFT_REQUEST_TYPE = "publish_draft";
export const PUBLISH_CHANGED_METADATA_REQUEST_TYPE = "publish_changed_metadata";
export const PUBLISH_NEW_VERSION_REQUEST_TYPE = "publish_new_version";
